import { ColDef, ICellRendererParams } from "ag-grid-community";
import { TagCell } from "../../../../ag-grid/components/common-cell-renderers/tag-cell/TagCell";
import { Tag, Tags } from "@/services/cloudchipr.api";

export const tagsColumnDef: ColDef = {
  minWidth: 210,
  sortable: false,
  field: "resource.tags",
  headerName: "Tags",
  valueGetter: ({ data }) =>
    data?.resource?.tags
      ?.map((tag: Tag) => `${tag.key}: ${tag.value}`)
      ?.join(", "),
  cellRenderer: ({ data }: ICellRendererParams) => {
    const tags = data?.resource?.tags as Tags;

    return <TagCell tags={tags ?? []} />;
  },
};
